//import toastr from 'toastr';

class AppError {
    constructor() {
        this.Init();
    }

    Init() {
        console.log('AppError.js');
    }

    // Afin de logger les erreurs dans les grids
    // Possibilité d'afficher des messages personnalisé en utilisant '# Mon custom message #'
    // Sinon renvoie Une erreur est survenue
    GridErrorHandler(e) {

        console.error('GridErrorHandler', e && e.status, e);

        toastr.options = {
            timeOut: 0,
            extendedTimeOut: 0
        };

        // e.xhr est absent sur une erreur de datasource, et responseText est vide sur un timeout
        var responseText = (e && e.xhr && e.xhr.responseText) ? e.xhr.responseText : '';

        // On affiche que la première partie du message entre #
        var potentielErrorMessage = responseText.split('#');

        // Pour récupérer le contenu entre les #
        if (potentielErrorMessage.length >= 3) { // Vérifie qu'il y a au moins deux occurrences de #
            let errorMsg = potentielErrorMessage[1];
            toastr.error(errorMsg);
        } else if (e && e.status === 'timeout') {
            toastr.error("Le chargement a pris trop de temps. Une opération de maintenance est peut-être en cours, réessayez dans quelques minutes.");
        } else {
            toastr.error("Une erreur est survenue");
        }
    }
}

module.exports = AppError;